import React, { Component } from "react";
import {COURSE_LIST_WIDTH, NAVBAR_HEIGHT} from "../../constants/cssConstants";
import Tabs from "../Tabs";
import {Button} from "@material-ui/core";
import logoPng from './../../assets/logo.png';
import Search from "./Search";
import request from "../../constants/requests";
import SchedulePanel from "../SchedulePanel/SchedulePanel";

const LOGOUT_BUTTON_WRAPPER_WIDTH = 165;

const TITLE_WRAPPER_WIDTH = 360;

class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: props.width
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.width !== this.props.width) {
            this.setState({ width: this.props.width })
        }
    }

    render() {
        const TABS_WRAPPER_WIDTH = this.state.width - COURSE_LIST_WIDTH
            - TITLE_WRAPPER_WIDTH - LOGOUT_BUTTON_WRAPPER_WIDTH;
        return(
            <div
                style={{
                    height: NAVBAR_HEIGHT,
                    width: this.state.width,
                    backgroundColor: "#006A96",
                    position: 'relative'
                }}
            >
                <Search
                    searchResultHeight={this.props.searchResultHeight}
                    token={this.props.token}
                    onLogout={this.props.onLogout}
                    addToPlanCoursesList={this.props.addToPlanCoursesList}
                />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ height: NAVBAR_HEIGHT, width: COURSE_LIST_WIDTH }}>
                        <img src={logoPng} style={{height: 120, width: 260}} />
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                            <div style={{ height: NAVBAR_HEIGHT - 31, width: TITLE_WRAPPER_WIDTH, display: 'flex',
                                alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{fontSize: 50,  textAlign: 'center', fontWeight: 'bold', color: 'white' }}>
                                    Triton Plan Pro
                                </div>
                            </div>
                            <div style={{ height: NAVBAR_HEIGHT - 31, display: 'flex', marginLeft: 10,
                                alignItems: 'center', justifyContent: 'center' }}>
                                <a style={{ textDecoration:'none'}}
                                   href={'https://www.ratemyprofessors.com/campusRatings.jsp?sid=1079'}
                                   target={ "_blank" }>
                                    <Button variant={'contained'} style={{ borderRadius: 24 }}>
                                        <div style={{ color: '#006A96', fontWeight: 'bold' }}>Rate My Prof</div>
                                    </Button>
                                </a>
                            </div>
                            <div style={{ height: NAVBAR_HEIGHT - 31, display: 'flex', marginLeft: 20,
                                alignItems: 'center', justifyContent: 'center' }}>
                                <a style={{ textDecoration:'none'}} href={'http://www.cape.ucsd.edu/'}
                                   target={"_blank" }>
                                <Button variant={'contained'} style={{ borderRadius: 24 }}>
                                    <div style={{ color: '#006A96', fontWeight: 'bold' }}>CAPES</div>
                                </Button>
                                </a>
                            </div>
                            <div style={{ height: NAVBAR_HEIGHT - 31, display: 'flex', marginRight: 30, marginLeft: 20,
                                alignItems: 'center', justifyContent: 'center' }}>
                                <Button variant={'contained'} style={{ borderRadius: 24 }} onClick={this.props.onLogout}>
                                    <div style={{ color: '#006A96', fontWeight: 'bold' }}>Log out</div>
                                </Button>
                            </div>
                        </div>
                        <div style={{ height: 31, width: this.state.width - 2 * COURSE_LIST_WIDTH, display: 'flex',
                            flexDirection: 'column-reverse' }}>
                            <Tabs
                                currentPlanId={ this.props.currentPlanId }
                                plans={ this.props.plans }
                                onSwitchPlan={ this.props.onSwitchPlan }
                                openAddPlanPopup={ this.props.openAddPlanPopup }
                                openDeletePlanPopup={ this.props.openDeletePlanPopup }
                                isLoading={this.props.isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavBar;